/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VocabularyTerm } from '../models/VocabularyTerm';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class VocabularyTermsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns VocabularyTerm
     * @throws ApiError
     */
    public vocabularyTermsList(): CancelablePromise<Array<VocabularyTerm>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/vocabulary-terms/',
        });
    }
    /**
     * @returns VocabularyTerm
     * @throws ApiError
     */
    public vocabularyTermsCreate({
        requestBody,
    }: {
        requestBody: VocabularyTerm,
    }): CancelablePromise<VocabularyTerm> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/vocabulary-terms/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns VocabularyTerm
     * @throws ApiError
     */
    public vocabularyTermsUpdate({
        vocabularyTermId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this vocabulary term.
         */
        vocabularyTermId: number,
        requestBody: VocabularyTerm,
    }): CancelablePromise<VocabularyTerm> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/vocabulary-terms/{vocabulary_term_id}/',
            path: {
                'vocabulary_term_id': vocabularyTermId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public vocabularyTermsDestroy({
        vocabularyTermId,
    }: {
        /**
         * A unique integer value identifying this vocabulary term.
         */
        vocabularyTermId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/vocabulary-terms/{vocabulary_term_id}/',
            path: {
                'vocabulary_term_id': vocabularyTermId,
            },
        });
    }
}
